import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useVuetify } from '@/composables/useVuetify'


export default /*#__PURE__*/_defineComponent({
  __name: 'LexonButtonComponent',
  props: {
  text: {
    type: String,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['lexonButtonEvent'],
  setup(__props, { emit }) {

const props = __props;



// DATA


// COMPOSABLES
const { breakpointName } = useVuetify()

// COMPUTED
const getText = computed(() => {
  return props.text ? props.text : 'components.lexon_button.default'
})

// EVENTS
function lexonButtonEvent() {
  emit('lexonButtonEvent')
}

return { __sfc: true,emit, props, breakpointName, getText, lexonButtonEvent }
}

})